import { Directive, ElementRef, HostBinding, Renderer2 } from '@angular/core';

@Directive({
  selector: '[followButton]',
  standalone: true
})
/**
 * Directive that checks if cookies are enabled before emiting an event to "onClickAfterCheck" only if cookies required
 * are enabled
 */
export class FollowButtonDirective {
  // @HostBinding('type') type = 'button';
  @HostBinding('icon') icon = 'pi pi-plus';
  @HostBinding('label') label = 'Follow';

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {
    this.addClassesAndAttributes();
  }

  addClassesAndAttributes() {
    const button = this.elementRef.nativeElement;

    this.renderer.addClass(button, 'button-primary');
    this.renderer.addClass(button, 'p-button');
    this.renderer.addClass(button, 'p-button-outlined');
    this.renderer.addClass(button, 'p-button-sm');
    this.renderer.addClass(button, 'follow-button');
  }
}
